<template>
  <div id="app">
    <!-- <router-view></router-view> -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>

export default {
  data() {
    return {
      detailRoutes: ['videoDetail', 'collectionVideo']
    }
  },
  computed: {
    keepAliveComponents() {
      let arr = []
      // 仅当我们在详情页时保持 searchList 组件活跃
      if (this.detailRoutes.includes(this.$route.name)) {
        arr = ['searchList'];
      }
      return arr;
    }
  },
  mounted() {

  },
  created() {
    var language = $.cookie('language');
    if(language!=''&&language!=null&&language!=undefined){
      this.$i18n.locale = language
    }else{
      $.cookie('language','zh-CN');
      this.$i18n.locale = 'zh-CN';
    }
  }
}
</script>

<style>
  html, body {
    height: 100%;
    margin: 0;
    background: #e8ebf3;
    font-size: 74.2188px;
    font-family: "Source Han Sans CN Regular","SimHei",Arial;
  }
  p {
    margin: 0;
  }
  span, p, div {
    box-sizing: border-box;
  }
  input {
    background-color: transparent;
    box-sizing: border-box;
  }
  select {
    border-radius: 0 !important;
    background-color: transparent;
  }
  ul {
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    list-style: none;
  }
  a:focus {
    outline: none;
  }
  #app {
      position: relative;
      width: 100%;
      height: auto;
      /* height: inherit; */
      min-height: 100%;
      overflow: hidden;
  }
</style>
